import { Dropbox } from 'dropbox';
import fetch from 'isomorphic-fetch';
import { isNil } from 'ramda';
import { ApiClient } from '~client/client/api-client';
import { GoogleMapsClient } from '~client/client/google-maps-client';
import { SpreedlyClient } from '~client/client/spreedly-client';
import { Config } from '~web/config';
import { logout } from '~web/interactor/user-login/perform-logout';
import { stores } from '~web/store';
import { AuthStore } from '~web/store/auth-store';

export const apiClient = new ApiClient({
  baseURL: Config.isDebugBuild ? '/api' : Config.api,
  withCredentials: !Config.isDebugBuild,
  unauthorizedCallback: (): void => {
    logout(true);
    // Refreshes the page to trigger AuthenticatedRoute redirect
    location.reload();
  },
  onExtractResponseBody: (response): void => {
    // Cookies used in the system get auto-extended lease every time a call is made. Mimic the same
    // extension for auth tokens for cases like DRM by updating the stored token.
    const updatedAuthToken = isNil(response.headers)
      ? null
      : // ApiSauce doesn't type response headers.
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        response.headers['authorization-extension'];
    if (!isNil(updatedAuthToken)) {
      const authStore = stores.authStore as AuthStore;
      // in debug mode we proxy the API so we use the header for auth to avoid CORS errors
      if (Config.isDebugBuild) {
        apiClient.setAuthorization(updatedAuthToken);
      }
      authStore.setAuthToken(updatedAuthToken);
    }
  },
});

export const spreedlyClient = new SpreedlyClient(Config.spreedlyKey, {
  baseURL: Config.spreedlyBaseUrl,
});

export const dropboxClient = new Dropbox({
  accessToken: Config.dropboxAccessToken,
  fetch,
});

export const googleMapsClient = new GoogleMapsClient(Config.googleMapApiKey, {
  baseURL: 'https://maps.googleapis.com',
});



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/web/src/js/client/index.ts